export default {
  state: {
    result: undefined,
    errors: undefined
  },

  result (result) {
    this.clearErrorsState()
    this.state.result = result
  },

  clearResultState () {
    this.state.result = undefined
  },

  // Convenience method.
  error (err) {
    this.clearResultState()
    this.state.errors = [ err ]
  },

  errors (errors) {
    this.clearResultState()
    this.state.errors = errors
  },

  clearErrorsState () {
    this.state.errors = undefined
  },

  clear () {
    this.clearResultState()
    this.clearErrorsState()
  }
}



// WEBPACK FOOTER //
// ./src/stores/FlashStore.js